import { render, staticRenderFns } from "./DashboardFinancial.vue?vue&type=template&id=6f573349"
import script from "./DashboardFinancial.vue?vue&type=script&lang=js"
export * from "./DashboardFinancial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports